import { TitleModel, DescriptionModel } from 'strapi/types';
import usePageDataStore from 'stores/pageDataStore';
import CenteredContainer, { CenteredContainerType } from '../CenteredContainer';
import TitleWithDescription from '../TitleWithDescription';
import ColorTable from '../ColorTable';
import useStyles from './styles';

type ColorDetailsProps = {
  showColorConversionTable?: boolean;
  details: {
    id: number;
    title: TitleModel;
    description: DescriptionModel;
  }[];
};

const ColorDetails = ({ details, showColorConversionTable }: ColorDetailsProps) => {
  const classes = useStyles();
  const showColorDetails = details && details.length > 0;
  const { hex } = usePageDataStore(store => store.colorData);
  const { data } = usePageDataStore(store => store.pageData);

  return (
    <CenteredContainer type={CenteredContainerType.small}>
      {showColorDetails &&
        details.map(detail => (
          <TitleWithDescription
            className={classes.blockSpaced}
            key={detail.id}
            title={detail.title}
            description={detail.description}
          />
        ))}
      {showColorConversionTable && <ColorTable colorHex={hex} name={data.name} />}
    </CenteredContainer>
  );
};

export default ColorDetails;
